import { useApi } from "../../../swr/useApi";
import { notificationsService } from "../../api_client";
import type { NotificationPrefsDto } from "../../../api";

/** The current user's saved email-notification preferences. */
export function useNotificationPrefs() {
  return useApi<NotificationPrefsDto>("my-notification-prefs", () =>
    notificationsService.getMyNotificationPrefs(),
  );
}
